export default {"src":"//a.static-global.com/floxy/floxy-web-user-center-ssr/_next/static/media/sao-dark.9718f84f.svg","height":181,"width":123};